export const FETCHING_CLIENTS = 'FETCHING_CLIENTS';
export const FETCHING_ALL_CLIENTS_DATA = 'FETCHING_ALL_CLIENTS_DATA';